import { Card, Group, Title, Grid, Text, Center, Loader, Button, Divider, Space } from "@mantine/core"
import { useParams } from "react-router-dom";
import { IconAdjustmentsHorizontal, IconPencil, IconPlus } from "@tabler/icons-react"
import moment from "moment"
import { useProgramsQuery, useProgramGroupsQuery } from "../../api/program.api";
import { useRegistrationByIdQuery } from "../../api/programregistration.api";
import { ViewRegistationPageParams } from "../../Pages/Registrations/View";
import { useProgramRegistrationState } from "../../state/programregistration.state";
import DetailsEditor from "./DetailsEditor";
import { formatDateRange } from "../../functions/programregistration.functions";
import ReservationLinkView from "./ReservationLinkView";

const DetailsView = () => {
	// const { registrationId } = useParams<ViewRegistationPageParams>();
	// const { data: registration, isLoading: isLoadingRegistration } = useRegistrationByIdQuery(Number(registrationId));
	const { programRegistration, isLoading: isLoadingRegistration, status, isCancelled } = useProgramRegistrationState();
	const { data: programs, isLoading: isLoadingPrograms } = useProgramsQuery();
	const { data: programGroups, isLoading: isLoadingProgramGroups } = useProgramGroupsQuery();
	
	const program = programs?.find(p => p.Id === (programRegistration?.Data.ProgramId ?? 0));
	const programGroup = programGroups?.find(p => p.Id === (programRegistration?.Data.ProgramGroupId ?? 0));

	const isSetup = status.isDetailsSetup;// programRegistration != null && programRegistration.ProgramId > 0 && programRegistration.ProgramGroupId > 0;

	const useNewDesign = import.meta.env.VITE_NEW_DESIGN === "true";

	return <>
		{useNewDesign && <>
		<Group justify="space-between" align="start" wrap="nowrap">
			<Group gap="xs" wrap="nowrap">
				{/* <IconAdjustmentsHorizontal /> */}
				<Title order={3}>Registration Details</Title>
			</Group>
			{!isLoadingRegistration &&
			// <Button variant="light" size="xs" mt={0} sx={{ alignSelf: 'flex-start' }}><IconPencil /> Edit</Button>
			<DetailsEditor add={!isSetup} />
			}
			{/* <Button variant="light" mt={-15}><IconPencil /> Edit</Button> */}
		</Group>
		<Divider my="sm" />

		{(isLoadingRegistration || isLoadingPrograms || isLoadingProgramGroups) && isSetup && <Center h={126} mx="auto">
			<Loader />
		</Center>}

		{!isSetup && programRegistration && <>
			{/* <Button variant="light" size="sm" mt={0} sx={{ alignSelf: 'flex-start' }}><IconPlus /> Select Program &amp; Dates</Button> */}
			{/* <DetailsEditor add={true} /> */}
			<Center h={100}>
				<Text c="dimmed">Start by adding a program and selecting dates</Text>
			</Center>
		</>}
		{!isLoadingRegistration && isSetup &&
		<Grid mb="xs">			
			<Grid.Col span={{ sm: 6 }}>
				<Text fw="bold">Registration #</Text>
				<Text fz="sm">{programRegistration.Data.Id}</Text>
				<Space h={10} />
				<Text fw="bold">Type</Text>
				<Text fz="sm">{programGroup?.Title}</Text>
				<Space h={10} />
				<Text fw="bold">Program</Text>
				<Text fz="sm">{program?.Title} ({program?.ShortDescription})</Text>
				{programRegistration?.Data?.Requests !== "" && <>
				<Space h={10} />
				<Grid.Col span={3} py={0}><Text ta="right" c="dimmed" size="sm">Special Requests:</Text></Grid.Col>
				<Grid.Col span={9} py={0}><Text>{programRegistration?.Data?.Requests}</Text></Grid.Col>
				</>}
			</Grid.Col>
			<Grid.Col span={{ sm: 6 }}>
				<Text fw="bold">Dates</Text>
				<Text fz="sm">{formatDateRange(programRegistration?.Data?.DateFrom, programRegistration?.Data?.DateTo)}</Text>
				<Space h={10} />
				{programRegistration.DateSubmitted && <>
				<Text fw="bold">Submitted</Text>
				<Text fz="sm">{moment(programRegistration?.DateSubmitted).format("LLL")}</Text>
				</>}
				{isCancelled && <>
				<Space h={10} />
				<Text fw="bold">Cancelled</Text>
				<Text fz="sm" c="orange" fw="bold">{moment(programRegistration.DateCancelled).format("LLL")}</Text>
				</>}
			</Grid.Col>
		</Grid>
		}
		</>}

		{!useNewDesign && <>
		<Card shadow="lg" withBorder mb="sm">
			<Group justify="space-between" mb="lg" align="start" wrap="nowrap">
				<Group gap="xs" wrap="nowrap">
					<IconAdjustmentsHorizontal />
					<Title order={3} lineClamp={2}>Registration Details</Title>
				</Group>
				{!isLoadingRegistration &&
				// <Button variant="light" size="xs" mt={0} sx={{ alignSelf: 'flex-start' }}><IconPencil /> Edit</Button>
				<DetailsEditor add={!isSetup} />
				}
				{/* <Button variant="light" mt={-15}><IconPencil /> Edit</Button> */}
			</Group>
			{(isLoadingRegistration || isLoadingPrograms || isLoadingProgramGroups) && isSetup && <Center h={126} mx="auto">
				<Loader />
			</Center>}
			{!isSetup && programRegistration && <>
				{/* <Button variant="light" size="sm" mt={0} sx={{ alignSelf: 'flex-start' }}><IconPlus /> Select Program &amp; Dates</Button> */}
				{/* <DetailsEditor add={true} /> */}
				<Center h={100}>
					<Text c="dimmed">Start by adding a program and selecting dates</Text>
				</Center>
			</>}
			{!isLoadingRegistration && isSetup &&
			<Grid mb="xs">
				<Grid.Col span={{ base: 4, md: 3 }} py={0}><Text ta="right" c="dimmed" size="sm">Registration #:</Text></Grid.Col>
				<Grid.Col span={{ base: 8, md: 9 }} py={0}><Text fw="bold">{programRegistration.Data.Id}</Text></Grid.Col>
				<Grid.Col span={{ base: 4, md: 3 }} py={0}><Text ta="right" c="dimmed" size="sm">Type:</Text></Grid.Col>
				<Grid.Col span={{ base: 8, md: 9 }} py={0}><Text>{programGroup?.Title}</Text></Grid.Col>
				<Grid.Col span={{ base: 4, md: 3 }} py={0}><Text ta="right" c="dimmed" size="sm">Program:</Text></Grid.Col>
				<Grid.Col span={{ base: 8, md: 9 }} py={0}><Text>{program?.Title} ({program?.ShortDescription})</Text></Grid.Col>
				<Grid.Col span={{ base: 4, md: 3 }} py={0}><Text ta="right" c="dimmed" size="sm">Dates:</Text></Grid.Col>
				<Grid.Col span={{ base: 8, md: 9 }} py={0}><Text>{formatDateRange(programRegistration?.Data?.DateFrom, programRegistration?.Data?.DateTo)}</Text></Grid.Col>
				{programRegistration.DateSubmitted && <>
				<Grid.Col span={{ base: 4, md: 3 }} py={0}><Text ta="right" c="dimmed" size="sm">Submitted:</Text></Grid.Col>
				<Grid.Col span={{ base: 8, md: 9 }} py={0}><Text>{moment(programRegistration?.DateSubmitted).format("LLL")}</Text></Grid.Col>
				</>}
				{isCancelled && <>
				<Grid.Col span={3} py={0}><Text ta="right" c="dimmed" size="sm">Cancelled:</Text></Grid.Col>
				<Grid.Col span={9} py={0}><Text color="orange" fw="bold">{moment(programRegistration.DateCancelled).format("LLL")}</Text></Grid.Col>
				</>}
				{programRegistration?.Data?.Requests !== "" && <>
				<Grid.Col span={3} py={0}><Text ta="right" c="dimmed" size="sm">Special Requests:</Text></Grid.Col>
				<Grid.Col span={9} py={0}><Text>{programRegistration?.Data?.Requests}</Text></Grid.Col>
				</>}
				<ReservationLinkView />
			</Grid>
			}
		</Card>
		</>}
	</>
}

export default DetailsView